import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostCategoriesInterface } from 'common/types/entities/BlogPostCategoriesInterface'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostCategories(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostCategories,
      parentId,
      masterBlockId,
    ),
    fontSize: 12,
    color: 'rgba(0, 116, 199, 1)',
    mobileFontSize: 12,
    alignSelf: 'left',
  } as BlogPostCategoriesInterface
}
